import React, {useEffect, useState} from 'react';
import {Box} from "@mui/system";
import Typography from "@mui/material/Typography";
import {Paper} from "@mui/material";
import WarehouseMaterialItemTable
    from "../../../../../components/UI/table/warehouse/material/materialwarehouse/WarehouseMaterialItemTable";
import {useLocation, useParams} from "react-router-dom";
import ButtonSelectAction from "../../../../../components/UI/button/ButtonSelectAction";
import {ModalSelectAction} from "../../../../../components/UI/modal/ModalSelectAction";
import ModalAlert from "../../../../../components/UI/table/customer-detales/ModalAlert";
import {BreadcrumbsComponent} from "../../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {constantsErrorMessages} from "../../../../../Constants";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";
import MaterialWarehouseService from "../../../../../API/orders/warehouse/material/MaterialWarehouseService";
import UtilityService from "../../../../../API/common/UtilityService";

const MaterialWarehouseArchive = () => {
    const pathname = useLocation().pathname
    const [rowSelection, setRowSelection] = useState([]);
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false)
    const [currencies, setCurrencies] = useState()
    const [createCuttingMapsModalOpen, setCreateCuttingMapsModalOpen] = useState(false);
    const [currencyMap, setCurrencyMap] = useState(new Map);

    const [alertData, setAlertData] = useState({});
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    const params = useParams();
    const id = params.id;
    const baseUnit = params.baseUnit;
    const typeMaterial = params.typeMaterial;
    const materialId = params.materialId;
    const materialName = params.materialName

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }

    useEffect(() => {
        UtilityService.getCurrencies()
            .then(function (response) {
                const data = response.data;
                data.forEach((c) => {
                    currencyMap.set(c.id, c);
                });
                setCurrencies(data)
            }).catch(function (error) {
            handleModalAlert(error)
        })
    }, []);

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    const modalActions = [
        {name: "Создать карты раскроя", type: "cuttingMaps"},
    ]
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    const handleSelectAction = () => {
        setOpen(false)
        setCreateCuttingMapsModalOpen(true)
    }

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Архив"}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Материалы", href: "/organization/materials"},
                    {
                        name: materialName,
                        href: `/organization/materials/${id}/${baseUnit}/${typeMaterial}/${materialId}`
                    },
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Архив материала {materialName}
                    </Typography>
                </Box>
                <WarehouseMaterialItemTable
                    getAll={MaterialWarehouseService.getAllByMaterialIdArchive}
                    id={id}
                    materialId={materialId}
                    baseUnit={baseUnit}
                    typeMaterial={typeMaterial}
                    material={data}
                    currencyMap={currencyMap}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    currencies={currencies}
                    handleModalAlert={handleModalAlert}
                    isArchive={true}
                />
                {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: "88px",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                }} component="footer">
                    <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
                </Paper>}
                <ModalSelectAction
                    open={open}
                    reset={() => setOpen(false)}
                    submit={handleSelectAction}
                    modalActions={modalActions}
                />
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                />
            </Box>
        </Box>
    );
};

export default MaterialWarehouseArchive;